/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelinboxtitle2Inputs */

const en_channelinboxtitle2 = /** @type {(inputs: Channelinboxtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replies`)
};

const de_channelinboxtitle2 = /** @type {(inputs: Channelinboxtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten`)
};

/**
* | output |
* | --- |
* | "Replies" |
*
* @param {Channelinboxtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelinboxtitle2 = /** @type {((inputs?: Channelinboxtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelinboxtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelinboxtitle2(inputs)
	return de_channelinboxtitle2(inputs)
});
export { channelinboxtitle2 as "channelInboxTitle" }